// The unit a state's tax BILLS print their rates in — used by the Document Scanner only when the bill can't tell
// (Philip 2026-10-22, decision A). A bill's stored total_tax_rate is always a PERCENT; a millage (per $1,000) rate is
// stored ÷10. The scanner decides the unit, in order:
//   1. the lines: each rated line's amount ÷ taxable value fits ÷1000 or ÷100 (reports/taxRate resolveRateUnit)
//   2. the bill's totals: Σ ad valorem ÷ taxable value against the summed rate (the scanner's rateCrossCheck)
//   3. the STATE, from this table — only when neither of the above can decide
//   4. percent, as before, for a state not in the table
// ⛔ ADD A STATE ONLY WHEN PHILIP HAS CONFIRMED IT (scripts/sql/tax_rate_units_by_state.sql lists what is stored per state).
export const STATE_BILL_UNIT = {
  FL: 'mills',   // Florida bills print millage (per $1,000)
  HI: 'mills',   // Hawaii (Maui) prints per $1,000 of value — millage by another name
  IL: 'percent',
  CA: 'percent',
  NV: 'percent', // Nevada prints per $100 (2.9328% on the Clark bills, Philip 2026-10-22)
  // CO: left out until Philip has checked a Denver bill (Colorado prints a mill levy on assessed value)
};

export const stateBillUnit = (state) => STATE_BILL_UNIT[String(state || '').trim().toUpperCase()] || null;

// The bill's one unit. lineUnit: resolveRateUnit's answer ({ confident, unit }); crossCheck: the scanner's
// { status: 'ok' | 'mills' | 'mismatch', multi } or null when it can't run yet.
export function pickBillRateUnit({ lineUnit, crossCheck, state }) {
  if (lineUnit?.confident) return lineUnit.unit;
  if (crossCheck && !crossCheck.multi && crossCheck.status === 'mills') return 'mills';
  if (crossCheck && !crossCheck.multi && crossCheck.status === 'ok') return 'percent';
  return stateBillUnit(state) || 'percent';
}
